export default __webpack_public_path__ + "static/media/Image7.3545a14b.jpg";